import TurfBuffer from '@turf/buffer';

import {polygon, featureCollection} from '@turf/helpers';
import circle from '@turf/circle';
import centroid from '@turf/centroid';

class LayerExclusion {
	

	
	constructor(du, scenario, tc) {
		
		this.scenario = scenario;
		this.map = du.map;
		this.du = du;
		this.tc = tc;
		//this.placeBoundaries();
		
	}
	
	
	
//	placeBoundaries(){
//		
//		var self = this;
//		var b = structuredClone(this.scenario.boundary);	
//		
//
//
//		if(this.map.getLayer(LayerExclusion.layerId)){
//			this.map.removeLayer(LayerExclusion.layerId);
//			this.map.removeSource(LayerExclusion.sourceId);
//		}
//
//				
//		if(!this.map.getSource(LayerExclusion.sourceId))
//			this.map.addSource(LayerExclusion.sourceId, {
//				'type': 'geojson',
//				'data': b.geometry
//			});
//
//		// Add a new layer to visualize the polygon.
//		if(!this.map.getLayer(LayerExclusion.layerId)){
//			this.map.addLayer({
//				'id': LayerExclusion.layerId,
//				'type': 'line',
//				'source': LayerExclusion.sourceId, // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['boundary'] ? 'visible' : 'none'
//				},
//				'paint': {
//					'line-color': LayerExclusion.defaultColor,
//					'line-opacity': 1,
//					'line-width' : LayerExclusion.defaultWidth
//				},
//				'filter': ['==', '$type', 'Polygon']
//			});
//
//		}
//	}
	json(){
		
		var self = this;
		var b = structuredClone(this.scenario.exclusion);	
		


		const l = {
				source : {
					'type'	: 'geojson',
					'data'	: this.convert(),
					'id': LayerExclusion.sourceId,
					'promoteId':'exclusion_id'
				},
				'images': [
					{
						'src': '/images/icons/point_marker.png',
						'name': 'ex_point_marker'
					}
				]
			};

		l.layer = [
	
				{
					'id': LayerExclusion.layerId,
					'type': 'fill',
					'source': LayerExclusion.sourceId, // reference the data source
					'paint': {
						'fill-color': ["get", "color"],
						'fill-opacity': ['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],.4,
							["*", .4, 
								['case',
									['boolean', ["to-boolean", ["get", "opacity"]], false], ["/", ["get", "opacity"], 100],
									1
								]
							]
						]
					},
					'filter': ['==', '$type', 'Polygon']
				},
				{
					'id': LayerExclusion.layerOutlineId,
					'type': 'line',
					'source': LayerExclusion.sourceId, // reference the data source
					'paint': {
						'line-color': ["get", "color"],
						'line-opacity': ['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],1,
							.4
						],
						'line-width': 3
					},
					'filter': ['==', '$type', 'Polygon']
				},
				{
					'id': LayerExclusion.layerPointsMarkerId,
					'type': 'symbol',
					'source': LayerExclusion.sourceId,
					"paint": {
						'text-color': ["get", "color"], //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
						'text-opacity':['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],1,
							1
						]
					}, // reference the data source
					'layout': {
						'text-field': ['case',
							['has', 'hidden'],'',
							['get', 'name']
						], //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
					'filter': [
						'all',
						['==', ['geometry-type'], 'Point'],
					]
				},
				
				
			
		];

		return l;
	}
	
	convert(){
		
		const polygons = [];
		const geom = structuredClone(this.scenario.exclusion ?? []);

		var auxLayers = [];
		
		geom.forEach((p, i) => {
			
			
			//exclusion point circle
			if(p.geometry.type == 'Point'){
				const newfeature = circle(p.geometry.coordinates, p.properties.radius, { 
					steps: 40, 
					units: "meters", 
					properties: { 
						color: p.properties.color, 
						exclusion_id:p.properties.exclusion_id ,
						invisible:p.properties.invisible ,
						type: 'point'
					} 
				});
				newfeature.id = LayerExclusion.generateCircleId(p.properties.exclusion_id) ?? p.properties.tempid;
				auxLayers.push(newfeature);
			}
			
			//Polygon Label feature
			if(p.geometry.type == 'Polygon'){
				
				const newfeature = centroid(p);
				newfeature.id = LayerExclusion.generateLabelId(p.properties.exclusion_id ?? p.properties.tempid);
				newfeature.properties = {
					"name" : p.properties.name,
					"color" : p.properties.color,
					"invisible": p.properties.invisible, 
					"exclusion_id" : p.properties.exclusion_id ?? p.properties.tempid,
					"type" : "label"
				}
				auxLayers.push(newfeature);
			}
			
		});


		geom.push(...auxLayers);
		geom.forEach((p, i) => {
			
			if(typeof p.properties["exclusion_id"] == 'undefined'){
				p.properties['exclusion_id'] = p.properties.exclusion_id;
				p.id = p.properties.exclusion_id;
			}
		});
		

		return featureCollection(geom);
	}
}

	
LayerExclusion.generateLabelId = function(originalId){
		
	return parseInt("100000"+originalId);
};	
LayerExclusion.generateCircleId = function(originalId){
		
	return parseInt("200000"+originalId);
};
LayerExclusion.layerId				= 'exclusion_layer';
LayerExclusion.layerOutlineId		= 'exclusion_layer_outline';
LayerExclusion.layerPointsId		= 'exclusion_points_layer';
LayerExclusion.layerPointsMarkerId	= 'exclusion_points_marker_layer';
LayerExclusion.layerPointsTextId	= 'exclusion_layer_labels'
LayerExclusion.sourceId				= 'exclusion_source';
LayerExclusion.defaultWidth			= 6;
LayerExclusion.defaultRadius		= 150;
LayerExclusion.defaultColor			= "#FC652E";
LayerExclusion.layers				= [
	{id: LayerExclusion.layerId },
	{id: LayerExclusion.layerPointsId },
	{id: LayerExclusion.layerOutlineId },
	{id: LayerExclusion.layerPointsMarkerId},
	{id: LayerExclusion.layerPointsTextId}
]


export default LayerExclusion;